// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mH1yy","left":"styles_left__qSdRq"};